import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { getProjects, getTermName } from '../../assets/js/api'
import Project from './Project';
import './assets/scss/styles.scss';
import Helmet from 'react-helmet';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { translate } from '../../assets/js/functions';

export default function ProjectsList(props){

    const [data, setData]   = useState(null);
    const title             = translate("Proyectos");
    const [id, setId]       = useState(null);
    const breadcrumbsStatic                 = [
        {name: translate("Entrevistas"), url: "/interviews"},
    ];

    useEffect(() => {
        if(props.match){
            const id = props.match.params.id;
            setId(id);
            if (id){
                getTermName(id).then(res => setData(res.data.result));
            }
        }
        getProjects().then(res => setData(res.data.result));
    }, []);

    return (
        <div id="projects">
            {!id ?
                <>
                    <Breadcrumbs key={id} staticData={breadcrumbsStatic} currentSite={title}/>
                    <h2>{title}</h2>
                    <Helmet>
                        <title>{title}</title>
                    </Helmet>
                    <Container>
                        <Row>
                            {projects()}
                        </Row>
                    </Container>
                </>
            :
                <Project {...props} />
            }
        </div>
    );

    function projects(){
        if (data)
            return data.map(
                res =>
                    <Col key={res.section_id} xs={12} md={3} className="theme-item project-item">
                        <Link className='btn-cmn' to={"/interviews/projects/"+res.section_id}>{res.name}</Link>
                    </Col>
            );
        else return <div className="loader1"><div></div><div></div></div>
    }
}
